var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:_vm.iconColor,attrs:{"size":"24"},on:{"click":_vm.toggleClinic}},[_vm._v(_vm._s('mdi-merge'))])
}
var staticRenderFns = []

export { render, staticRenderFns }